export default {
  'clocks': [
    'clock0900_1100',
    'clock1100_1300',
    'clock1400_1600',
    'clock1600_1800'
  ],
  'permanentRequiredFields': [
    'RequestInterest',
    'Salutation',
    'FirstName',
    'LastName',
    'Email',
    'RequestMessage'
  ],
  'requiredFields': {
    'default': [
      'Company',
      'PostalCode',
      'VATNumber'
    ],
    'consulting': [
      'Company',
      'PostalCode',
      'RequestTopic',
      'VATNumber'
    ],
    'offersGeneral': [
      'Company',
      'PostalCode',
      'RequestTopic',
      'VATNumber'
    ],
    'offersInvestment': [
      'PostalCode',
      'VATNumber'
    ],
    'other': [
      'RequestMessage'
    ],
    'customer_serviceGeneral': [
      'Company',
      'PostalCode',
      'RequestTopic',
      'RequestMessage',
      'VATNumber'
    ],
    'customer_serviceBank': [
      'RequestTopic',
      'RequestMessage',
      'VATNumber'
    ],
    'investor_relations': [
      'RequestMessage',
      'VATNumber'
    ],
    'cooperation': [
      'Company',
      'PostalCode',
      'RequestTopic',
      'RequestMessage',
      'VATNumber'
    ]
  },
}
